import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import i18n from 'i18n-js';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import { BaseModal } from 'components/UI';
import { Formik, Form, Field, useFormikContext } from 'formik';
import { TextField } from 'components/FormFields';
import { LocationsSelect } from 'components/AsyncFields';

export const TaxRulesetsModal = ({ open, handleClick, index, current, loading }) => {
  const [location, setLocation] = useState(null);

  const formSchema = Yup.object().shape({
    location_id: Yup.number().required(i18n.t('common.required_field')),
    rate: Yup.number()
      .typeError(i18n.t('common.type_error'))
      .required(i18n.t('common.required_field'))
      .min(0, i18n.t('common.min_0'))
      .max(100, i18n.t('common.max_100')),
  });

  const formRef = useRef(null);
  const {
    setFieldValue,
    values: { taxes = [] },
  } = useFormikContext();

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  const initialValues = {
    location_id: current?.location_id || '',
    rate: current?.rate * 100 || '',
  };

  const handleSubmit = (values) => {
    const payload = { ...current, ...values, rate: values.rate / 100 };
    if (location) payload.location = location;

    if (current) {
      // Update
      setFieldValue(
        'taxes',
        taxes.map((tax, i) => (i === index ? payload : tax))
      );
    } else {
      // Add
      setFieldValue('taxes', [...taxes, payload]);
    }
    handleClick();
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      loading={loading}
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      enterButtonLabel={i18n.t('common.save')}
      title={i18n.t(`tax_ruleset.tax_modal.${current ? 'update' : 'create'}`)}
    >
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={formSchema}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Grid data-cy="invoice-item-modal" container spacing={2}>
              <Grid item xs={12}>
                <Field
                  margin="none"
                  name="location_id"
                  id="LocationSelect"
                  component={LocationsSelect}
                  label={i18n.t('common.location')}
                  onChange={(loc) => setLocation(loc)}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  name="rate"
                  type="text"
                  margin="none"
                  component={TextField}
                  label={i18n.t('tax_ruleset.tax_modal.tax')}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

TaxRulesetsModal.propTypes = {
  current: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

TaxRulesetsModal.defaultProps = {
  open: false,
  handleClick: () => {},
};
